import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation } from "react-router-dom";
import Header from "./Header2";

function Navbar() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const location = useLocation(); // Access the current route

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };
  const drawerList = (
    <div
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
      style={{ backgroundColor: "black", height: "1000vh", color: "#dfb162" }}
    >
      <List>
        <ListItem
          button
          style={{ color: "#dfb162" }}
          component={Link}
          to="/"
          className={location.pathname === "/" ? "current" : ""}
        >
          <ListItemText primary="Home" />
        </ListItem>

        <ListItem
          button
          style={{ color: "#dfb162" }}
          component={Link}
          to="/woman/Necklace"
          className={location.pathname === "/woman/Necklace" ? "current" : ""}
        >
          <ListItemText primary="Women's: Necklace" />
        </ListItem>
        <ListItem
          button
          style={{ color: "#dfb162" }}
          component={Link}
          to="/woman/Bracelet"
          className={location.pathname === "/woman/Bracelet" ? "current" : ""}
        >
          <ListItemText primary="Women's: Bracelet" />
        </ListItem>
        <ListItem
          style={{ color: "#dfb162" }}
          button
          component={Link}
          to="/woman/Earrings"
          className={location.pathname === "/woman/Earrings" ? "current" : ""}
        >
          <ListItemText primary="Women's: Earrings" />
        </ListItem>
        <ListItem
          style={{ color: "#dfb162" }}
          button
          component={Link}
          to="/woman/Pendantset"
          className={location.pathname === "/woman/Pendantset" ? "current" : ""}
        >
          <ListItemText primary="Women's: Pendant set" />
        </ListItem>
        <ListItem
          style={{ color: "#dfb162" }}
          button
          component={Link}
          to="/woman/Ring"
          className={location.pathname === "/woman/Ring" ? "current" : ""}
        >
          <ListItemText primary="Women's: Ring" />
        </ListItem>
        <ListItem
          style={{ color: "#dfb162" }}
          button
          component={Link}
          to="/woman/Mangalsutra"
          className={
            location.pathname === "/woman/Mangalsutra" ? "current" : ""
          }
        >
          <ListItemText primary="Women's: Mangalsutra" />
        </ListItem>
        <ListItem
          style={{ color: "#dfb162" }}
          button
          component={Link}
          to="/woman/Bengal"
          className={
            location.pathname === "/woman/Bengal" ? "current" : ""
          }
        >
          <ListItemText primary="Women's: Bangel" />
        </ListItem>
        <ListItem
          style={{ color: "#dfb162" }}
          button
          component={Link}
          to="/woman/Coupleband"
          className={
            location.pathname === "/woman/Coupleband" ? "current" : ""
          }
        >
          <ListItemText primary="Women's: Coupleband" />
        </ListItem>
        <ListItem
          button
          style={{ color: "#dfb162" }}
          component={Link}
          to="/man/Bracelet"
          className={location.pathname === "/man/Bracelet" ? "current" : ""}
        >
          <ListItemText primary="Men's: Bracelet" />
        </ListItem>
        <ListItem
          button
          style={{ color: "#dfb162" }}
          component={Link}
          to="/man/Ring"
          className={location.pathname === "/man/Ring" ? "current" : ""}
        >
          <ListItemText primary="Men's: Ring" />
        </ListItem>
        <ListItem
          button
          style={{ color: "#dfb162" }}
          component={Link}
          to="/service"
          className={location.pathname === "/service" ? "current" : ""}
        >
          <ListItemText primary="Services" />
        </ListItem>
        <ListItem
          button
          style={{ color: "#dfb162" }}
          component={Link}
          to="/about"
          className={location.pathname === "/about" ? "current" : ""}
        >
          <ListItemText primary="About Us" />
        </ListItem>
        <ListItem
          style={{ color: "#dfb162" }}
          button
          component={Link}
          to="/contact"
          className={location.pathname === "/contact" ? "current" : ""}
        >
          <ListItemText primary="Contact" />
        </ListItem>
      </List>
    </div>
  );

  return (
    <>
      <Header />
      {/* Navbar Section */}
      <AppBar position="static" sx={{ backgroundColor: "#111" }}>
        <Container>
          <Toolbar sx={{ justifyContent: "space-between" }}>
            <Typography>
              <Link to="/">
                <img
                  style={{ height: "10vh", width: "13vh" }}
                  src="/images/New_logo.png"
                  alt="Vamagems"
                  title="Vamagems"
                />
              </Link>
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
              sx={{
                marginLeft: "20vh",
                display: { xs: "block", md: "none" },
              }}
            >
              <MenuIcon />
            </IconButton>
            <div
              className="clearfix"
              sx={{ display: { xs: "none", md: "block" } }}
            >
              <nav className="main-menu navbar-expand-md navbar-light">
                <div
                  className="collapse navbar-collapse clearfix"
                  id="navbarSupportedContent"
                >
                  <ul className="navigation clearfix">
                    <li
                      className={
                        location.pathname === "/"
                          ? "current dropdown"
                          : "dropdown"
                      }
                    >
                      <Link to="/">Home</Link>
                    </li>

                    <li
                      className={
                        location.pathname.startsWith("/woman")
                          ? "current dropdown"
                          : "dropdown"
                      }
                    >
                      <Link to="#">Women's</Link>
                      <ul>
                        <li>
                          <Link to="/woman/Necklace">Necklace</Link>
                        </li>
                        <li>
                          <Link to="/woman/Bracelet">Bracelet</Link>
                        </li>
                        <li>
                          <Link to="/woman/Earrings">Earrings</Link>
                        </li>
                        <li>
                          <Link to="/woman/Pendantset">Pendant set</Link>
                        </li>
                        <li>
                          <Link to="/woman/Ring">Ring</Link>
                        </li>
                        <li>
                          <Link to="/woman/Mangalsutra">Mangalsutra</Link>
                        </li>
                        <li>
                          <Link to="/woman/Bengal">Bangel</Link>
                        </li>
                        <li>
                          <Link to="/woman/Coupleband">Couple band's</Link>
                        </li>
                      </ul>
                    </li>
                    <li
                      className={
                        location.pathname.startsWith("/man")
                          ? "current dropdown"
                          : "dropdown"
                      }
                    >
                      <Link to="#">Men's</Link>
                      <ul>
                        <li>
                          <Link to="/man/Bracelet">Bracelet</Link>
                        </li>
                        <li>
                          <Link to="/man/Ring">Ring</Link>
                        </li>
                      </ul>
                    </li>

                    <li
                      className={
                        location.pathname === "/service"
                          ? "current dropdown"
                          : "dropdown"
                      }
                    >
                      <Link to="/service">Services</Link>
                    </li>
                    <li
                      className={
                        location.pathname === "/about"
                          ? "current dropdown"
                          : "dropdown"
                      }
                    >
                      <Link to="/about">About Us</Link>
                    </li>
                    <li
                      className={
                        location.pathname === "/contact" ? "current" : ""
                      }
                    >
                      <Link to="/contact">Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </Toolbar>
        </Container>
      </AppBar>
      <Drawer
        anchor="left"
        style={{ marginLeft: "200px" }}
        open={drawerOpen}
        onClose={toggleDrawer(false)}
      >
        {drawerList}
      </Drawer>
    </>
  );
}

export default Navbar;
